import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import {EmailSendResponse, ErrorResponse, Rental, RentalDocumentType, TransportDto} from '../api/dtos/dtos';
import {IdPageUrlParams} from '../paths';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {idFromPathParams} from "../utils/router-utils";
import furoApi from "../api/FuroApi";
import RentalDetailsAlert from "../checklist/send/RentalDetailsAlert";
import locales from "../locales";
import {ErrorAlert} from "../common/ErrorAlert";
import SendDocumentForm from "./SendDocumentForm";
import {showConfirm} from "../utils/dialogs";
import {setAppHeaderSubtitle} from "../app/AppHeader";
import {showEmailSendResultModal} from "../common/EmailSendResultModal";
import {PaymentType} from "../common/PaymentType";

interface State {
  rental?: Rental;
  hasTransport?: boolean;
  showDeposit?: boolean;
  error?: ErrorResponse;
}

class SendRentalDocumentsPage extends React.Component<RouteComponentProps<IdPageUrlParams>, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {
      hasTransport: false,
      showDeposit: false,
    };
  }

  public componentDidMount() {
    this.loadRental();
    this.loadRentalTransport();
  }

  public render() {
    const {error, rental, hasTransport, showDeposit} = this.state;

    const documentTypes: RentalDocumentType[] = [
      RentalDocumentType.TERMS_AND_CONDITIONS,
      RentalDocumentType.MAINTENANCE_GUIDE,
      RentalDocumentType.RENTAL_CONTRACT,
    ];
    if (hasTransport) {
      documentTypes.push(RentalDocumentType.TRANSPORT_LETTER);
    }
    if (showDeposit) {
      documentTypes.push(RentalDocumentType.DEPOSIT_REQUEST);
    }

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>
        {rental &&
            <RentalDetailsAlert
                rental={rental}
                rentalTitle={locales.rental}
            />
        }
        {rental &&
            <SendDocumentForm
                clientId={rental.client!.id!}
                documentTypes={documentTypes}
                onFormCancel={this.onFormCancel}
                onFormSubmit={this.onFormSubmit}
            />
        }
        <ErrorAlert style={{marginTop: '16px'}} error={error}/>
      </>
    );
  }

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private onFormSubmit = (documentTypes: RentalDocumentType[], contactIds: number[]) => {
    showConfirm(locales.document_send_confirm, () => this.sendRentalDocuments(documentTypes, contactIds));
  };


  private sendRentalDocuments = (documentTypes: RentalDocumentType[], recipientContactIds: number[]) => {
    const rentalID = idFromPathParams(this.props);
    const promise = furoApi.document.sendRentalDocuments(rentalID, {recipientContactIds, documentTypes})
      .then(this.onSendResponse)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  }

  private onSendResponse = (response: EmailSendResponse) => {
    showEmailSendResultModal({
      title: locales.email_send_result_document,
      response,
      onSuccess: this.pop
    });
  };

  private pop = () => {
    this.props.history.goBack();
  }

  private loadRental = () => {
    const rentalID = idFromPathParams(this.props);
    const promise = furoApi.rentals.get(rentalID)
      .then(this.onRentalLoaded)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onRentalLoaded = (response: Rental) => {
    this.setState({
      rental: response,
      showDeposit: (response.paymentType === PaymentType.TRANSFER && response.rentalItems?.some((i) => i.caution !== undefined && i.caution > 0)) ?? false,
    });
  };

  private loadRentalTransport = () => {
    const rentalID = idFromPathParams(this.props);
    const promise = furoApi.rentals.getTransport(rentalID)
      .then(this.onLoadTransport)
      .catch(this.onApiError)
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onLoadTransport = (response: TransportDto | null) => {
    this.setState({
      hasTransport: response !== null,
      error: undefined,
    });
    setAppHeaderSubtitle(this.props, locales.document_send_subtitle);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  }
}

export default SendRentalDocumentsPage;




// WEBPACK FOOTER //
// ./src/document-sendout/SendRentalDocumentsPage.tsx